module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/monitor-pc/monitorPC.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/monitor-pc/monitorPC.png
// module id = 597
// module chunks = 0